export const OPERATORS: { value: string; label: string }[] = [
  {
    label: "==",
    value: "==",
  },
  {
    label: "!=",
    value: "!=",
  },
  {
    label: ">",
    value: ">",
  },
  {
    label: "<",
    value: "<",
  },
  {
    label: ">=",
    value: ">=",
  },
  {
    label: "<=",
    value: "<=",
  },
];


export const STRING_OPERATORS: { value: string; label: string }[] = [
  {
    label: "==",
    value: "==",
  },
  {
    label: "!=",
    value: "!=",
  },
];